import Modal, { Sheets, ModalHeader, ModalBody, ModalFooter } from '@ingka/modal';
type SkapaProps = {
  visible: boolean;
  children: React.ReactNode;
  escapable?: boolean;
  handleCloseBtn: (e?: React.MouseEvent<Element, MouseEvent | undefined>) => void;
  onModalClosed?: (e: AnimationEvent) => void;
  header?: React.ComponentProps<typeof ModalHeader> | null;
  footer?: React.ComponentProps<typeof ModalFooter> | null;
  sheetProps?: React.ComponentProps<typeof Sheets>;
  focusLockProps?: { autoFocus?: boolean };
  'data-testid'?: string;
  style?: React.CSSProperties;
  alignment?: 'left' | 'right';
};

// Just a thin wrapper
const Sheet = (props: SkapaProps) => {
  const modalHeader = props.header ? <ModalHeader {...props.header} /> : null;
  const modalFooter = props.footer ? <ModalFooter {...props.footer} /> : null;
  const modalAlignment = props.alignment ? props.alignment : 'right';

  return (
    <Modal {...props}>
      <Sheets
        {...props.sheetProps}
        header={modalHeader}
        footer={modalFooter}
        alignment={modalAlignment}
      >
        <ModalBody>{props.children}</ModalBody>
      </Sheets>
    </Modal>
  );
};

export default Sheet;
